import { extractApiErrorMessage } from './extract-api-error-message'
import {
  extractData,
  extractStatus,
  extractMedia,
  parseMidjourneyImagePoll,
  toDataMediaUrl
} from './aim-unified-poll-common'

/**
 * /aim/call 统一轮询 — video：model_type=video（含 generations）
 */
export function runWanUnifiedPollVideoBranch(args) {
  var stateData = args.stateData
  var modelName = args.modelName
  var modelType = args.modelType
  var finishWithParsed = args.finishWithParsed
  var scheduleNext = args.scheduleNext
  var callback = args.callback
  var postDownloadVideo = args.postDownloadVideo
  var stopPoll = args.stopPoll

  /* 有 generations[] 时以条内 status/url 为准（Wan、Seedance、Sora 等），勿被外层 data.code=SUCCESS 误判 */
  var genPoll = parseMidjourneyImagePoll(stateData)
  if (genPoll) {
    if (genPoll.kind === 'wait') {
      if (typeof callback === 'function') callback(null, { status: 'processing' })
      scheduleNext()
      return
    }
    if (genPoll.kind === 'failed') {
      finishWithParsed({ status: 'failed', error: genPoll.error || '生成失败' })
      return
    }
    if (genPoll.kind === 'need_download') {
      /* Hailuo：已有地址则不下载；否则有 fileId 才 download_video */
      if (modelName === 'hailuo') {
        var mediaSkipHl = extractMedia(stateData)
        if (mediaSkipHl.url) {
          finishWithParsed({ status: 'completed', url: mediaSkipHl.url })
          return
        }
        if (mediaSkipHl.base64) {
          finishWithParsed({ status: 'completed', url: toDataMediaUrl(mediaSkipHl.base64, modelType) })
          return
        }
        if (genPoll.fileId && typeof postDownloadVideo === 'function') {
          postDownloadVideo(genPoll.fileId).then(function (downloadRes) {
            var downloadData = extractData(downloadRes)
            var mediaDl = extractMedia(downloadData)
            if (mediaDl.url) {
              finishWithParsed({ status: 'completed', url: mediaDl.url })
              return
            }
            if (mediaDl.base64) {
              finishWithParsed({ status: 'completed', url: toDataMediaUrl(mediaDl.base64, modelType) })
              return
            }
            var msgDl = extractApiErrorMessage(downloadData) || '未返回视频结果'
            finishWithParsed({ status: 'failed', error: msgDl })
          }).catch(function (errDl) {
            if (typeof callback === 'function') callback(errDl, null)
            if (typeof stopPoll === 'function') stopPoll()
          })
          return
        }
        if (typeof callback === 'function') callback(null, { status: 'processing' })
        scheduleNext()
        return
      }
      /* Sora：query_state 仅 succeed，真实地址在 download_video */
      if (modelName === 'sora' && typeof postDownloadVideo === 'function') {
        postDownloadVideo().then(function (downloadRes) {
          var downloadData = extractData(downloadRes)
          var mediaDl = extractMedia(downloadData)
          if (mediaDl.url) {
            finishWithParsed({ status: 'completed', url: mediaDl.url })
            return
          }
          if (mediaDl.base64) {
            finishWithParsed({ status: 'completed', url: toDataMediaUrl(mediaDl.base64, modelType) })
            return
          }
          var msgDl = extractApiErrorMessage(downloadData) || '未返回视频结果'
          finishWithParsed({ status: 'failed', error: msgDl })
        }).catch(function (errDl) {
          if (typeof callback === 'function') callback(errDl, null)
          if (typeof stopPoll === 'function') stopPoll()
        })
        return
      }
      if (typeof callback === 'function') callback(null, { status: 'processing' })
      scheduleNext()
      return
    }
    if (genPoll.kind === 'done' && genPoll.url) {
      finishWithParsed({ status: 'completed', url: genPoll.url })
      return
    }
  }
  var statusVid = extractStatus(stateData)
  if (statusVid === 'failed') {
    var errMsgVid = extractApiErrorMessage(stateData) || '生成失败'
    finishWithParsed({ status: 'failed', error: errMsgVid })
    return
  }
  if (statusVid !== 'completed') {
    if (typeof callback === 'function') callback(null, { status: 'processing' })
    scheduleNext()
    return
  }
  var mediaVid = extractMedia(stateData)
  if (mediaVid.url) {
    finishWithParsed({ status: 'completed', url: mediaVid.url })
    return
  }
  if (mediaVid.base64) {
    finishWithParsed({ status: 'completed', url: toDataMediaUrl(mediaVid.base64, modelType) })
    return
  }
  var errVid = extractApiErrorMessage(stateData) || '未返回视频结果'
  finishWithParsed({ status: 'failed', error: errVid })
}
